import {
  Box, DashboardModule, Form,
} from '@domain-group/suit-theme'

import ToggleListItem from '@components/ToggleListItem'

import useProviderPriceListItem, { useProviderPriceListItemForm } from '@hooks/useProviderPriceListItem'

import PriceListItemOptions from './PriceListItemOptions'

interface PriceListItemDetailProps {
  callbacks: {
    showCreateOrEditProviderPriceListItemOptionModal: (payload: object) => void,
    showCreateOrEditProviderPriceListItemOptionValueModal: (payload: object) => void,
  },
  isMaster: boolean,
  providerPriceListItemId: number,
}

const PriceListItemDetail = (props: PriceListItemDetailProps) => {
  const {
    callbacks,
    isMaster,
    providerPriceListItemId,
  } = props

  const providerPriceListItemPayload = useProviderPriceListItem({ id: providerPriceListItemId })
  const {
    callbacks: {
      updateProviderPriceListItem: updateFn,
    },
    providerPriceListItem,
    serviceProviders,
  } = providerPriceListItemPayload

  const { api_pricing } = providerPriceListItem

  const priceListItemForm = useProviderPriceListItemForm(providerPriceListItem)
  const {
    entityState,
    entityState: {
      api_pricing_service_provider,
      price,
      quantity,
    },
    handlers,
  } = priceListItemForm

  return (
    <>
      <DashboardModule contentBoxProps={{ flexDirection: 'column' }} title="Details">
        <Form padding="large">
          <Form.Row columns="repeat(3, 1fr)">
            <Form.Field label="* Quantity">
              <input
                disabled={!isMaster}
                name="quantity"
                value={quantity}
                onBlur={() => updateFn(entityState)}
                onChange={handlers.onChange}
                type="number"
              />
            </Form.Field>

            <Box marginTop="auto">
              <Form.Field label={isMaster ? '* Default Price' : '* Base Price'}>
                <input
                  name="price"
                  value={price}
                  style={{ width: 'auto' }}
                  onBlur={() => updateFn(entityState)}
                  onChange={handlers.onChange}
                  type="number"
                />
              </Form.Field>

              <Form.Field label="API Pricing" style={{ marginLeft: 5 }}>
                {/*
                 // @ts-expect-error TS2741 */}
                <ToggleListItem
                  boxProps={{ fontSize: '16px' }}
                  onClick={() => updateFn({
                    api_pricing: !api_pricing,
                    api_pricing_service_provider: '',
                  })}
                  toggleValue={api_pricing}
                />
              </Form.Field>
            </Box>
          </Form.Row>

          {api_pricing && (
            <Form.Row>
              <Form.Field label="Service Provider">
                <select
                  data-value-type="text"
                  name="api_pricing_service_provider"
                  onChange={e => updateFn({ api_pricing_service_provider: e.target.value })}
                  value={api_pricing_service_provider || ''}
                >
                  <option value="">Please Select...</option>

                  {serviceProviders.map((serviceProvider) => {
                    const { key, title } = serviceProvider
                    return <option key={key} value={key}>{title}</option>
                  })}
                </select>
              </Form.Field>
            </Form.Row>
          )}

        </Form>
      </DashboardModule>

      <PriceListItemOptions
        callbacks={callbacks}
        isMaster={isMaster}
        providerPriceListItem={providerPriceListItem}
      />
    </>
  )
}

export default PriceListItemDetail
